import { useBackend } from "../../services";

export const useSendNotificationEmails = () => {
  const { post } = useBackend();
  return async () => post("admin/sendNotificationEmails", {});
};
